export const primaryColor = '#0055b3';
export const dangerColor = '#E54441';
